module.exports = __webpack_public_path__ + "static/democratsandautocrats-9f52689bc7adb45af06d37198078579a.jpg";